export default __webpack_public_path__ + "locales/ui.bua.json";